module.exports = __webpack_public_path__ + "static/media/gray-rectangle.e9097df6.svg";